import { RowRegistration } from 'app/shared/features/map-row-selector/models/row-registration';
import { RowRegistrationStatus } from 'src/app/shared/features/map-row-selector/models/row-registration-status';

export type RowRegistrationStatusDict = {
    [rowRegistrationKey: string]: RowRegistrationStatus;
};

export const registrationToRowRegistrationStatusDict = ({
    activityNumber,
    rowRegistrations,
}: {
    activityNumber: number;
    rowRegistrations: RowRegistration[];
}) => {
    return rowRegistrations.reduce((dict: RowRegistrationStatusDict, rowRegistration) => {
        const rowRegistrationDictKey = getRowRegistrationDictKey({
            activityNumber,
            rowNumber: rowRegistration.rowNumber,
        });
        dict[rowRegistrationDictKey] = rowRegistration.registrationStatus;
        return dict;
    }, {});
};

export const registrationListToRowRegistrationStatusDict = (
    registrations: {
        activityNumber: number;
        rowRegistrations: RowRegistration[];
    }[],
) => {
    return registrations.reduce(
        (aggregate, registration) => ({
            ...aggregate,
            ...registrationToRowRegistrationStatusDict(registration),
        }),
        {},
    );
};

export const getRowRegistrationDictKey = ({
    activityNumber,
    rowNumber,
}: {
    activityNumber: number;
    rowNumber: number;
}): string => {
    return activityNumber + '_' + rowNumber;
};

export const matchRowRegistrationKeyWithActivity = ({
    rowRegistrationKey,
    activityNumber,
}: {
    rowRegistrationKey: string;
    activityNumber: number;
}): boolean => rowRegistrationKey.startsWith(activityNumber + '_');
